import * as React from "react";
import { styled } from "styled-components";

import logoLibertySrc from "./logo-liberty.svg";

const PublicLayoutWrapper = styled.main`
  max-width: 34rem;
  padding: 0 3rem 4rem;
  margin: 4rem auto 4rem auto;
`;

export const LayoutCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colours.bordersLight};
  background: ${({ theme }) => theme.colours.white};
  border-radius: 6px;
  padding: 2rem;
  display: grid;
  gap: 2rem;
`;

const LogoImg = styled.img`
  max-width: 10rem;
  display: block;
  margin: auto;
  margin-bottom: 2rem;
`;

export const PublicLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <PublicLayoutWrapper data-testid="public-layout">
      <LayoutCard>
        <LogoImg src={logoLibertySrc} alt="Entia Liberty" />
        {children}
      </LayoutCard>
    </PublicLayoutWrapper>
  );
};
